module.exports = __webpack_public_path__ + "static/eye-sculpture-trail-social-31e1f4bcc79ba8b608e6bce03fed8657.png";